<script>
export default {
  name: 'OrderDataUpdateDateDisplay'
}
</script>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { dateUtil } from '@functions/dateUtil.js';
import axios from 'axios';
import { url } from '@/config/urls';
import router from '@/router/index.js';

// Prop定義
const props = defineProps({
  orderDataUpdateDateApiUrl: {
    type: String,
    default: url.api.orderDataUpdateDate
  },
  loginUrl: {
    type: String,
    default: url.login
  }
});

// リロードボタン押下時のemit
const emits = defineEmits(['updateLatestList']);

// 外部定義メソッド
const { dateStringToDateObject, dayToDayString } = dateUtil();

// データ更新日時
const updateDate = ref({
  date: '',
  day: '',
  time: '',
})

// タイムスタンプ文字列から表示値への変換
const convertDisplayValue = (timestamp) => {
  // タイムスタンプ文字列の分割
  const regexp = /([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/;
  const capture = regexp.exec(timestamp);
  const date = dateStringToDateObject(capture[1], capture[2], capture[3]);

  updateDate.value.date = capture[1] + '/' + parseInt(capture[2]) + '/' + parseInt(capture[3]);
  updateDate.value.day = dayToDayString(date.getDay());
  updateDate.value.time = capture[4] + ':' + capture[5];
}

// データ更新日取得
const getOrderDataUpdateDate = () => {
  axios.get(props.orderDataUpdateDateApiUrl)
    .then((response) => {
      convertDisplayValue(response.data.response.updateTime ? response.data.response.updateTime : "2000-01-01 00:00:00");
    })
    .catch((error) => {
      switch(error?.response?.status) {
        case 401:
          router.replace(props.loginUrl);
          break;
        default: break;
      }
    })
}

// リロードボタン
const clickReloadBtn = () => {
  // データ更新日時の最新化
  getOrderDataUpdateDate();
  // 検索結果の最新化
  emits('updateLatestList');
}

onMounted(() => {
  nextTick(() => {
    getOrderDataUpdateDate();
  });
})
</script>

<template>
  <div class="com_update1">
    <dl>
      <dt>データ更新日時</dt>
      <dd>{{updateDate.date}}<span>({{updateDate.day}})</span> {{updateDate.time}} 時点</dd>
    </dl>
    <button class="com_icon_reload toggle1" @click="clickReloadBtn"></button>
  </div>
</template>